// extracted by mini-css-extract-plugin
export default {"characterSheetIcon":"styles_characterSheetIcon__NQH1m","disabled":"styles_disabled__QQt8w"};